import TabPannel from "../aboutUs/Tabs/TabPannel";
import Container from "../aboutUs/Container";

import { XadamatFani, Forosh, Amozesh } from "../aboutUs";

const AboutUs = ({ value, handleChange }) => {
  return (
    <>
      <div>
        <Container>
          <TabPannel value={value} index={0}>
            <XadamatFani></XadamatFani>
          </TabPannel>
          <TabPannel value={value} index={1}>
            <Forosh></Forosh>
          </TabPannel>
          <TabPannel value={value} index={2}>
            <Amozesh></Amozesh>
          </TabPannel>
        </Container>
      </div>
    </>
  );
};
export default AboutUs;
